import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import { mapMutations } from 'vuex';

export var stepForm = {
    methods: _extends({}, mapMutations({
        changeStep: 'affiliations/form/setStep'
    }))
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/step-form.js
// module id = ./src/mixins/step-form.js
// module chunks = 34